import { render, staticRenderFns } from "./selectz.vue?vue&type=template&id=2912a1cd&scoped=true&"
import script from "./selectz.vue?vue&type=script&lang=js&"
export * from "./selectz.vue?vue&type=script&lang=js&"
import style0 from "./selectz.vue?vue&type=style&index=0&id=2912a1cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2912a1cd",
  null
  
)

export default component.exports